import { CalendarDate } from '@internationalized/date';

const convertDatetoCalenderDate = (date) => {
  const createNewDate = new CalendarDate();
  const setNewDate = createNewDate.set({
    year: new Date(date).getFullYear(),
    month: new Date(date).getMonth() + 1,
    day: new Date(date).getDate(),
  });
  return setNewDate;
};

export default convertDatetoCalenderDate;
